/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Confirm_Delete_AudioInputs */

const en_dialog_confirm_delete_audio = /** @type {(inputs: Dialog_Confirm_Delete_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm delete audio?`)
};

const es_dialog_confirm_delete_audio = /** @type {(inputs: Dialog_Confirm_Delete_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Confirmar eliminación del audio?`)
};

/**
* | output |
* | --- |
* | "Confirm delete audio?" |
*
* @param {Dialog_Confirm_Delete_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_confirm_delete_audio = /** @type {((inputs?: Dialog_Confirm_Delete_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Confirm_Delete_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_confirm_delete_audio(inputs)
	return en_dialog_confirm_delete_audio(inputs)
});